// People cards (destination teams): card editor with a role per destination, the card list
// and the link to a guide profile.
export const people = {
  edit: {
    roleAtDestination: "Role at this destination",
    sortAtDestination: "Order at this destination",
    othersLabel: "Also at this destination:",
    othersNone: "Nobody else at this destination yet.",
    otherItem: "{{name}} ({{role}}, order {{order}})",
    inactive: "inactive",
    noDestinations: "A card with no destinations is not shown on destination pages.",
    guideProfile: "Guide profile",
    guideProfileNone: "No guide profile",
    guideProfileHint: "The profile link shows on the website only for an active guide.",
  },
  list: {
    rolesColumn: "Roles",
    allRoles: "All roles",
    noDestinations: "No destinations — not shown on destination pages",
  },
};
